import Header from './Header'

function Layout({children}) {
  return (
    <>
        <Header/>
        <div className='main-container'>{children}</div>
    </>
  )
}

export default Layout